module.exports = __webpack_public_path__ + "static/img/h5.c81db52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h5.jpg
// module id = MyOJ
// module chunks = 0